app.service('productPriceVariants', function(productCardTest, price, broker) {
	let $self, $customPriceBox, $customPriceValue, $priceVariantValue, $customPriceInput, $priceVariantItem;

	function setElements () {
		$priceVariantItem = $self.find('.js-price-variant-item');
		$customPriceBox = $self.find('.custom-price-variant-box');
		$customPriceValue = $self.find('#custom-price-value-text');
		$customPriceInput = $self.find('#custom-price-input');
		$customPriceEdit = $self.find('.js-custom-product-price-edit');
		$customPriceConfirm = $self.find('.js-custom-product-price-confirm');
	}

	function setEvents (){
		$priceVariantItem.on('click', function () {
			$priceVariantItem.removeClass('selected');
			$(this).addClass('selected');
			$customPriceBox.removeClass('active').removeClass('selected'); // usuwa selecta z customowego wariantu
			$customPriceValue.text(''); // czyści customową kwotę
			setToCartProductPrice($(this).data('price')*1); // wartość liczbowa z data-price predefiniowanego wariantu
		});

		$customPriceEdit.on('click', function () {
			$customPriceBox.addClass('active');
		});

		$customPriceConfirm.on('click', function () {
			validateMinMaxValue($customPriceInput);
			const customPrice = $customPriceInput.val()*1;
			const formattedCustomPrice = price.format(customPrice);
			$customPriceBox.removeClass('active').addClass('selected'); // dodaje selecta do customowego wariantu
			$priceVariantItem.removeClass('selected'); // usuwa selecta z predefiniowanych wariantów
			$customPriceValue.text(formattedCustomPrice);
			setToCartProductPrice(customPrice);
		});

		$customPriceInput.keyfilter(/[0-9.,]/).on('paste', function (event) {
			event.preventDefault();
			const clipboardText = ((event.originalEvent || event).clipboardData || window.clipboardData).getData('text') || '';
			$(this).val(clipboardText.replace(',', '.').replace(/[^0-9.]/g, ''));
			validateMinMaxValue($(this));
		}).on('blur', function () {
			$(this).val($(this).val().replace(',', '.').replace(/[^0-9.]/g, ''));
			validateMinMaxValue($(this));
		});

	}
	function validateMinMaxValue ($input) {
		const minValue = $input.attr('min')*1;
		const maxValue = $input.attr('max')*1;
		let value = $input.val().replace(',', '.')*1;
		if (value < minValue) {
			value = minValue;
		} else if (value > maxValue) {
			value = maxValue;
		}
		$input.val(value);
	}

	function setToCartProductPrice (productPrice) {
		broker.trigger('PRODUCT_PRICE_VARIANT_CHANGE', { productPrice: productPrice });
	}

	function init () {
		$self = $('#product-price-variants');
		if($self.length) {
			setElements();
			setEvents();
		};
	}

	return {
		init: init
	};

});
